// Where the screen goes once someone is signed in (code, passkey or Google all
// come through here).
import type { QueryClient } from "@tanstack/react-query";
import type { Api } from "@trameria/ui-core";
import { accountQuery } from "../queries";
import { HOME } from "./next";
import { passkeyPromptDismissed } from "./passkey-name";

/**
 * The waitlist for an account not approved yet (unless it came to accept an
 * invite: joining approves it); once, the passkey page for an account without
 * one (unless this browser said "later"); else `next` or Me.
 */
export async function signInDestination(
  queryClient: QueryClient,
  api: Api,
  next: string | undefined,
): Promise<string> {
  const account = await queryClient.fetchQuery({
    ...accountQuery(api),
    staleTime: 0,
  });
  if (!account.approved)
    return next?.startsWith("/invite/") ? next : "/waitlist";
  if (account.passkeys === 0 && !passkeyPromptDismissed())
    return `/passkey?next=${encodeURIComponent(next ?? HOME)}`;
  return next ?? HOME;
}
